module.exports = __webpack_public_path__ + "img/zoom_in_black_24dp.9ab40f46.svg";